import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@iconify/react';
import { SearchFilters, FilterId } from '../../../types/search';
import { filterConfigs } from '../FilterMenu/config';
import { useSelectedValues } from '../FilterMenu/useSelectedValues';
import { Topic } from '../../../types/topic';

type ActiveFilter = {
  id: FilterId;
  value: string;
  label: string;
  section: string;
};

interface ActiveFiltersProps {
  filters: SearchFilters;
  onRemove: (filterId: FilterId, value: string) => void;
  topics: Topic[];
}

export const ActiveFilters: React.FC<ActiveFiltersProps> = ({ filters, onRemove, topics }) => {
  const { t } = useTranslation();

  const getAllActiveFilters = (): ActiveFilter[] => {
    return filterConfigs.flatMap(config => {
      const selectedValues = config.getSelectedValues(filters);
      const labels = useSelectedValues(config, filters, t, topics);
      
      return selectedValues.map((value, index) => ({
        id: config.id as FilterId,
        value,
        label: labels[index],
        section: t(config.titleKey)
      }));
    });
  };

  const activeFilters = getAllActiveFilters();
  if (activeFilters.length === 0) return null;

  return (
    <div className="flex items-center flex-wrap gap-2">
      <span className="text-sm text-text-secondary font-medium">
        {t('search.activeFilters')}:
      </span>
      {activeFilters.map(filter => (
        <button 
          key={`${filter.id}-${filter.value}`}
          onClick={() => onRemove(filter.id, filter.value)}
          className="text-sm text-text-primary bg-surface-secondary hover:bg-surface-tertiary px-2 py-1 rounded-md border border-border-primary inline-flex items-center gap-1.5 transition-colors group"
        >
          {filter.label}
          <Icon 
            icon="ph:x-bold" 
            className="w-3 h-3 text-text-primary opacity-30 group-hover:opacity-100 transition-opacity" 
          />
        </button>
      ))}
    </div>
  );
}; 